<template>
  <v-card class="c-card d-flex flex-column">
    <v-skeleton-loader
      v-bind="attrs"
      class="c-channel-skeleton pb-5"
      :types="{
        'channel-heading': 'heading',
        'channel-excerpt': 'paragraph',
        'channel-action-bar': 'button, avatar@3'
      }"
      type="image, channel-heading, channel-excerpt, channel-action-bar"
    />
  </v-card>
</template>

<script>
export default {
  name: 'ChannelCardSkeleton',

  components: {},

  data: function () {
    return {
      attrs: {
        elevation: 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-card {
  height: 100%;
  max-width: min(400px, 100%);
  border-radius: 16px;
}

.c-channel-skeleton {
  :deep(.v-skeleton-loader__channel-heading) {
    margin-top: 16px;
    padding: 0 16px;
  }

  :deep(.v-skeleton-loader__channel-excerpt) {
    margin-top: 16px;
    padding: 0 16px;
  }

  :deep(.v-skeleton-loader__channel-action-bar) {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  :deep(.v-skeleton-loader__channel-action-bar .v-skeleton-loader__channel-actions) {
    justify-self: end;
  }
}
</style>
